import {combineReducers} from 'redux'
import {connectRouter} from 'connected-react-router'
import seo from './seo'
import path from './path'
import filters from './filters'
import products from './products'
import pagination from './pagination'
import tags from './tags'

import breadcrumbs from '../../ItemApp/ducks/breadcrumbs'
import buyInOneClick from '../../ItemApp/ducks/buy-in-one-click'
import product from '../../ItemApp/ducks/product'
import itemSeo from '../../ItemApp/ducks/itemSeo'
import locationData from '../../ItemApp/ducks/location-data'
import reviews from '../../ItemApp/ducks/reviews'
import url from '../../ItemApp/ducks/url'
import cartInfo from '../../ItemApp/ducks/cart-info'
import isAdmin from '../../ItemApp/ducks/is-admin'
import licenseeStore from '../../ItemApp/ducks/licensee-store'

const createRootReducer = (history) =>
    combineReducers({
        // common
        router: connectRouter(history),
        buyInOneClick,
        isMobile: (state = false) => state,
        currency: (state = {}) => state,
        onPlatform: (state = null) => state,
        authenticityToken: (state = '') => state,
        path,

        // store
        seo,
        filters,
        products,
        pagination,
        tags,
        isCustomStore: (state = false) => state,
        ownDesignAllowed: (state = false) => state,
        categories: (state = []) => state,
        sort: (state = []) => state,

        // item
        url,
        breadcrumbs,
        product,
        itemSeo,
        locationData,
        reviews,
        cartInfo,
        isAdmin,
        licenseeStore,
    })

export default createRootReducer
